(function () {
  'use strict';ShopifyUpsellController.$inject = ["$uibModal", "$state", "$rootScope", "Profile", "Funnel", "currency", "mesSystem"];

  angular.
  module('gplans.store.controllers').controller('ShopifyUpsellModalCtrl', ["$scope", "$rootScope", "$uibModalInstance", "$state", "$http", "$localStorage", "UserService", "$window", "gplansConf", "Snackbar", "Profile", "Funnel", "product", "quantity", "amount", function (
  $scope,
  $rootScope,
  $uibModalInstance,
  $state,
  $http,
  $localStorage,
  UserService,
  $window,
  gplansConf,
  Snackbar,
  Profile,
  Funnel,
  product,
  quantity,
  amount)
  {
    $scope.close = close;
    $scope.user = angular.copy(UserService.data);
    $scope.buy = buy;
    $scope.getUpsellPaypalTokenRequest = getUpsellPaypalTokenRequest;
    $scope.onUpsellPaypalSuccess = onUpsellPaypalSuccess;
    $scope.calculate = calculate;
    $scope.loading = false;
    $scope.errorEmail = false;
    $scope.payment_method = $localStorage['payment_method'] || 'RECURLY';
    var tax = 0.0725 + 0.0225 + 0.0075;
    var shipping = 10;
    $scope.total_amount = amount;

    function calculate() {
      if ($scope.user.province) {
        $scope.shipping = shipping;
        $scope.total_amount = amount;
        if ($scope.user.province == 'California') {
          $scope.tax = amount * tax;
          $scope.tax = parseFloat($scope.tax.toFixed(2));
        } else
        {
          $scope.tax = 0;
        }
        $scope.total_amount += $scope.shipping;
        $scope.total_amount += $scope.tax;
        $scope.total_amount = parseFloat($scope.total_amount.toFixed(2));
      } else {
        $scope.shipping = null;
        $scope.tax = null;
        $scope.total_amount = null;
      }
    }

    function buy() {
      $scope.loading = true;
      $scope.errorEmail = false;
      var variants = [
      { variant_id: product, quantity: quantity }];

      var customer = {
        "first_name": $scope.user.first_name,
        "last_name": $scope.user.last_name,
        "email": $scope.user.email };

      var shipping_address = {
        "first_name": $scope.user.first_name,
        "last_name": $scope.user.last_name,
        "email": $scope.user.email,
        "phone": $scope.user.cell_phone,
        "address1": $scope.user.address1,
        "city": $scope.user.city,
        "province": $scope.user.province,
        "country": $scope.user.country,
        "zip": $scope.user.zip };

      var order = {
        customer: customer,
        amount: $scope.total_amount,
        variants: variants,
        shipping_address: shipping_address };

      Profile.purchaseShopify(order).then(function (res) {
        $scope.loading = false;
        if (res.data.success) {
          if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: amount });
          // VWO
          if (amount) $window.VWO.push(['track.revenueConversion', amount]);

          $uibModalInstance.dismiss('close');
          Funnel.nextStep();
        } else
        {
          if (res.data.error && res.data.email)
          $scope.errorEmail = res.data.email;else
          if (res.data.error.customer) {
            $scope.errorEmail = res.data.error.customer[0];
          } else

          Snackbar.error(res.data.error);
        }
      }, function (err) {
        $scope.loading = false;
        Snackbar.error('Something wrong, try again later or contact support');
      });
    }

    function onUpsellPaypalSuccess(response) {
      var params = {
        payment_id: response.paymentID,
        payer_id: response.payerID };

      $http.post(gplansConf.API_URL + '/api/v1/paypal/payment/execute/',
      params).then(function (result) {
        if (result.data.success) {
          buy();
        } else
        {
          Snackbar.error("There was a problem processing your payment.");
        }
      },
      function (err) {
        Snackbar.error("There was a problem processing your payment.");
      });
    }

    function getUpsellPaypalTokenRequest() {
      $scope.loading = true;
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
        json: {
          amount: $scope.total_amount,
          currency: "USD",
          description: 'Upsell Products' } };


    }

    function close() {
      $uibModalInstance.dismiss('close');
    }
  }]).
  controller('ShopifyUpsellController', ShopifyUpsellController);

  ShopifyUpsellController.$inject = ['$uibModal', '$state', '$rootScope', 'Profile', 'Funnel', 'currency', 'mesSystem'];

  function ShopifyUpsellController($uibModal, $state, $rootScope, Profile, Funnel, currency, mesSystem) {
    var vm = this;
    vm.productVariantId = 13876393542; // this is lean
    vm.price = {
      1: 47,
      3: 126,
      6: 234 };

    activate();

    function activate() {

      Profile.getMisc('shopifyPurchase').then(function (res) {
        var data = JSON.parse(res.data.value);
        if (data.order_created) {
          Funnel.nextStep();
        }
      });

      /*
          Profile.getShopifyProducts().then(function (res) {
            vm.products = res.data.products;
            vm.products = vm.products.map(function (product) {
              product.quantity = 1;
              return product;
            })
          })
          */
    }
    /*
      vm.countSum = function(){
        vm.sum = 0;
        for (var i=0; i<vm.products.length; i++) {
          var product = vm.products[i];
          if (product.checked) {
            vm.sum += product.variants[0].price * product.quantity;
          }
        }
      };
      */

    vm.openBuyModal = function (quantity) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'templates/store/upsell-shopify.modal.html',
        controller: 'ShopifyUpsellModalCtrl',
        resolve: {
          product: vm.productVariantId,
          quantity: quantity,
          amount: vm.price[quantity] } });


    };
  }
})();